const img = /(jpg|jpeg|pjpeg|gif|png)$/;

export const regex = {
  img
};
